import { Link } from 'react-router';
import logo from './images/logo.png';
import prjimg from './images/project.png';
import clntimg from './images/client.png';
import testimg from './images/test.png';
import userimg from './images/user.jpeg';
import vdrimg from './images/vendor.jpeg';
import lgimg from './images/logout.png';
import dnld from './images/exls.png';
function SideBar()
{
    return(
        <>
            <div className="offcanvas offcanvas-start bg-light text-dark" id="mysidebar" style={{width:'150px',fontFamily:'Roboto Serif'}}>  
            <div className="offcanvas-header">
                <Link to="/dashboard"><img src={logo} alt="" className='shadow rounded-5' width="30px" /></Link>
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
            </div>
                <div className="offcanvas-body">                    
                    <h6>CCFT</h6>     
                    <div className="sidelink  mt-1">
                        <Link to="/projects" className='text-decoration-none' ><img className='border rounded-1 shadow' src={prjimg} width="30px" /><span className='ms-2 text-secondary'>Projects</span></Link>
                    </div>    
                    <div className="sidelink  mt-1">
                        <Link to="/clients"  className='text-decoration-none'><img className='border rounded-1 shadow' src={clntimg} width="30px" /><span className='ms-2 text-secondary'>Clients</span></Link>
                    </div>        
                    <div className="sidelink  mt-1">
                        <Link to="/tests"  className='text-decoration-none'><img className='border rounded-1 shadow' src={testimg} width="30px" /><span className='ms-2 text-secondary'>Tests</span></Link>
                    </div>                     
                    <div className="sidelink  mt-1">
                        <Link to="/users"  className='text-decoration-none'><img className='border rounded-1 shadow' src={userimg} width="30px" /><span className='ms-2 text-secondary'>Users</span></Link>
                    </div>               
                    <div className="sidelink mt-1">
                        <Link to="/vendors"  className='text-decoration-none'><img className='border rounded-1 shadow' src={vdrimg} width="30px" /><span className='ms-2 text-secondary'>Vendors</span></Link>
                    </div>
                    <div className="sidelink mt-1">
                        <Link to="/reports"  className='text-decoration-none'><img className='border rounded-1 shadow' src={dnld} width="30px" /><span className='ms-2 text-secondary'>Reports</span></Link>
                    </div>
                    <hr/>
                    <div className="sidelink mt-1">
                        <Link to="/logout"  className='text-decoration-none'><img className='border rounded-1 shadow' src={lgimg} width="30px" /><span className='ms-2 text-secondary'>Logout</span></Link>
                    </div>
                </div>    
            </div>
            <div className="row bg-dark">
                <div className="col-1">
                    <button className="btn btn-sm btn-dark" type="button" data-bs-toggle="offcanvas" data-bs-target="#mysidebar">
                        <span className='fw-bold'>&#x2630;</span>
                    </button>                
                </div>
                <div className="col-11">
                    <div className="text-white">Welcome {window.uname}</div>
                </div>
            </div>
        </>
    );
}
export default SideBar;